import { Injectable } from '@angular/core';
import { encryptionService } from 'src/app/common-service/cedService';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { urlServices } from '../Models/url.models';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class UsrmgtService {

  constructor(public http: HttpServiceService, private httpClient: HttpClient, public url: urlServices, public ced: encryptionService,
    public serverURL: ServerURLService) { }

  getRandomKeyGeneratorForViewDocument() {
    return this.http.get(this.url.getRandomKeyGeneratorForViewDocument);
  }

  // All Get Calls
  // Get All Users 
  getAllUsers(pageId: number, rows: number) {
    return this.http.get(this.url.userList + '?page=' + pageId + '&rows=' + rows);
  }
  // Get All Roles
  getRoles() {
    return this.http.get(this.url.allRoles);
  }
  // Get All Prvilizes
  getPrevilizes() {
    return this.http.get(this.url.allPrevilizes);
  }
  // Get All Groups
  getGroups(pageId, rows) {
    return this.http.get(this.url.allGroups + '?page=' + pageId + '&rows=' + rows);
  }

  // Search Api Calls 
  // group search
  groupSearch(data: any, pageId: number, rows: number) {
    return this.http.get(this.url.searchByGroup + '?searchWord=' + data + '&page=' + pageId + '&rows=' + rows);
  }
  // privileges search
  privilegesSearch(data: any, pageId: number, rows: number) {
    return this.http.get(this.url.searchByPrvilize + '?searchInput=' + data + '&page=' + pageId + '&rows=' + rows);
  }
  // roles search 
  rolesSearch(data: any, pageId: number, rows: number) {
    return this.http.get(this.url.searchByRole + '?searchInput=' + data + '&page=' + pageId + '&rows=' + rows);
  }
  // users search 
  usersSearch(data: any, pageId: number, rows: number) {
    return this.http.get(this.url.searchByData + '?searchInput=' + data + '&page=' + pageId + '&rows=' + rows);
  }
  // pagination for group data
  paginationforGroupData(pageid: number, rowid: number) {
    return this.http.get(this.url.paginationForGroupData + '?page=' + pageid + '&rows=' + rowid);
  }

  getAllSectionByEntityMaster(selectId: number) {
    return this.http.get(this.url.getAllSectionByEntityMaster + '?entityMasterId=' + selectId);
  }

  getAllDesignationByEntityMaster(selectId: number) {
    return this.http.get(this.url.getAllDesignationByEntityMaster + '?entityMasterId=' + selectId);
  }

  getAllUserTypes() {
    return this.http.get(this.url.getAllUserTypes);
  }
  // getEntityMaster
  getEntityMaster() {
    return this.http.get(this.url.getEntityMaster);
  }
  
  getCollegeUserEntityId(collegeId: any) {
    return this.http.get(this.url.getCollegeUserEntityId + '?collegeId=' + collegeId);
  }

  getEntityMasterByCollegeUser(entityMasterId: any) {
    return this.http.get(this.url.getEntityMasterByCollegeUser + '?entityMasterId=' + entityMasterId);
  }

  getAllCollegeList() {
    return this.http.get(this.url.getAllCollegeList);
  }
  getAllUniversityList() {
    return this.http.get(this.url.getAllUniversityList);
  }

  // getAllCollegesByUgApproved
  getAllCollegesByUgApproved() {
    return this.http.get(this.url.getAllCollegesByUgApproved);
  }

  // getAllCollegesByUgApproved
  getAllCollegesByCourseBDS() {
    return this.http.get(this.url.getAllCollegesByCourseBDS);
  }

  // getAllCollegesByPgApproved
  getAllCollegesByCourseMDS() {
    return this.http.get(this.url.getAllCollegesByCourseMDS);
  }

   // getAllCollegesByPgApproved
   getAllCollegesByCourseMDSGovt() {
    return this.http.get(this.url.getAllCollegesByCourseMDSGovt);
  }

   // getAllCollegesByPgApprovedSpec
   getAllCollegesByCourseMDSSpecGovt(specId: any) {
    const specIdEncr = encodeURIComponent(this.ced.encryptAesToString(specId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getAllCollegesByCourseMDSSpecGovt + "?specIdEncr=" + specIdEncr);
  }

  // findAllCounsellingAuthorities
  findAllCouncellingAuthorities() {
    return this.http.get(this.url.getAllCounsellingAuthorities);
  }
  // findAllSdcs
  findAllSdcs() {
    return this.http.get(this.url.getAllSdcs);
  }
  // findAllUniversities
  findAllUniversitiesByState(stateName: any) {
    return this.http.get(this.url.getAllUniversitiesByState + "?stateName=" + stateName);
  }

  // findAllColleges
  findAllColleges() {
    return this.http.get(this.url.getAllColleges);
  }
   // findAllCollegesWithInActive
   findAllCollegesWithInActive() {
    return this.http.get(this.url.getAllCollegesWithInActive);
  }
  // getAllCollegesByState
  getAllCollegesByState() {
    return this.http.get(this.url.getAllCollegesByState);
  }

  GetCollegeListForSARSection(collegeSearchCriteria: any) {
    return this.http.post(this.url.GetCollegeListForSARSection, collegeSearchCriteria);
  }
  
 exportCollegeListForSARSection(searchPayload: any) {

  return this.httpClient.post(
    this.url.ExportExcelForSARSection,
    searchPayload,
    {
      headers: new HttpHeaders({
        'Accept':
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      responseType: 'blob'
    }
  );
}
  // post calls
  // create Role
  createRole(obj) {
    return this.http.post(this.url.createRole, obj);
  }
  // create User
  createUser(obj) {
    return this.http.post(this.url.createUser, obj);
  }

  // update Calls
  // update Role
  updateRole(obj) {
    return this.http.update(this.url.updateRole, obj);
  }
  // update user
  updateUser(obj) {
    return this.http.update(this.url.updateUser, obj);
  }

  assiognRole(data: any) {
    return this.http.update(this.url.assignRoleToUser, data);
  }
  getAllPrivillages(privillagePageid: number, privillageRowId: number) {
    return this.http.get(this.url.getAllPrivillage + '?page=' + privillagePageid + '&rows=' + privillageRowId)
  }
  getAllGroupsForDropDown() {
    return this.http.get(this.url.allGroupsForDropDown)

  }
  //ListOfPrivillagesByGroup
  ListOfPrivillagesByGroup(groupId, pageId, rowId) {
    return this.http.get(this.url.ListOfAllPriviligesByGroup + '?groupId=' + groupId + '&page=' + pageId + '&rows=' + rowId)
  }
  //getAllRoles
  getAllRoles(groupPageid: any, groupRowId: any) {
    return this.http.get(this.url.getAllRoles + '?page=' + groupPageid + '&rows=' + groupRowId)
  }
  updateRoleData(obj: any) {
    return this.http.update(this.url.updateRoleData, obj)
  }

  exportUserExcel(searchPayload: any) {
  return this.http.post(this.url.exportUsersExcel, searchPayload);
}


  getRoleDetailsById(roleId: any) {
    return this.http.get(this.url.getRoleDetailsByRoleId + '?id=' + roleId)
  }
  //   roleIdUpdate(obj:any){
  //   return this.http.update(this.url.updateRoleId,obj);
  // }
  updateRoleAuthority(privillagesObj: any) {
    return this.http.update(this.url.updateRoleIdS, privillagesObj)
  }
  // filterWithRoleorUsertype
  filterWithRoleOrUsertype(pageId: number, rows: number, obj) {
    return this.http.post(this.url.filterWithRoleorUserType + '?page=' + pageId + '&rows=' + rows, obj);
  }
  // getUserByUserId
  getUserByUserId(id) {
    return this.http.get(this.url.getUserDetailById + '?id=' + id);
  }
  //getUserByUserDetailsId

  getUserByUserDetailsId(id) {
    return this.http.get(this.url.getUserDetailByIds + '?id=' + id);
  }
  //  getAllCountries
  getAllCountrie() {
    return this.http.get(this.url.getAllCountrie);
  }
  // Dentist Dropdown List
  getDentistDropdownList() {
    return this.http.get(this.url.getDentistDropdownList);
  }
  // getAllStates
  getAllStates(countryId: any) {
    return this.http.get(this.url.getAllStates + '?countryId=' + countryId);
  }
  // getAllStates By Name
  getAllStatesByCountryName(countryName: any) {
    return this.http.get(this.url.getAllStatesByCountryName + '?countryName=' + countryName);
  }
  countryList() {
    return this.http.get(this.url.getAllCountrie);
  }
  // getAllCities
  getAllCities(stateId: any) {
    return this.http.get(this.url.getAllCities + '?stateId=' + stateId);
  }
  getAllCitiesByStateName(stateName: any) {
    return this.http.get(this.url.getAllCitiesByStateName + '?stateName=' + stateName);
  }
  getAllPrivilligesByRole() {
    return this.http.get(this.url.getAllPrivillizeaByRole);
  }
  // inActiveUser
  inActiveUser(data) {
    return this.http.post(this.url.inActiveTheUser, data);
  }

  getStateById(stateId) {
    return this.http.get(this.url.getStateById + '?stateId=' + stateId)
  }

  getStateByName(stateName) {
    return this.http.get(this.url.getStateByName + '?stateName=' + stateName)
  }

  getCityById(cityId: any) {
    return this.http.get(this.url.getCityById + '?cityId=' + cityId)
  }
  getSectionById(sectionId: any) {
    return this.http.get(this.url.getSectionById + '?sectionId=' + sectionId)
  }
  restePassword(resetObj) {
    return this.http.update(this.url.resetPassword, resetObj);
  }

  forgotPassword(resetObj) {
    return this.http.post(this.url.forgotPassword, resetObj);
  }
  
  ViewDocument(filePath: any) {
    return this.http.post(this.url.ViewDocument, filePath);
  }

  updateRemarksCollege(data: any) {
    return this.http.post(this.url.updateRemarksCollege, data);
  }

  GetUserByEmailId(userEmailId: any) {
    return this.http.get(this.url.serrchByEmail + "?emailId=" + userEmailId);
  }

  //getCollegeDetails
  getCollegeDetails() {
    const obj = {
      entityMasterId: this.ced.encryptAesToString(sessionStorage.getItem('entityId-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getCollegeDetails, obj);
  }

  //getCollegeDetails
  getCollegeDetailsForSection(entityId: any) {
    const obj = {
      entityMasterId: this.ced.encryptAesToString(entityId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getCollegeDetails, obj);
  }

  getCaptchaImage() {
    return this.http.get(this.url.getCaptchaImage);
  }

  getCaptchaValue() {
    return this.http.get(this.url.getCaptchaValue);
  }


  getSeekAproverUserListUptoSecIncharge() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.seekAproverUserListUptoSecIncharge, obj);
  }

  getSeekApprovalUserListSecretaryIncharge() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.seekApprovalUserListSecretaryIncharge, obj);
  }

  getCorrectionUsersList() {
    const obj = {
      sectionIdEncr: this.ced.encryptAesToString(JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.correctionUserList, obj)
  }

  // getCorrectionUsersListSIInspection() {
  //   //Academic Section - 3
  //   const obj = {
  //     sectionIdEncr: this.ced.encryptAesToString("3", this.serverURL.secretKey).toString()
  //   }
  //   return this.http.post(this.url.correctionUserList, obj)
  // }

  getCorrectionUserListSIInspection() {
  return this.http.post(this.url.correctionUsersList, {});
}
  getCorrectionUsersListSIInspection(sectionId: string) {
    const obj = {
      sectionIdEncr: this.ced.encryptAesToString(sectionId, this.serverURL.secretKey).toString()
    };

    return this.http.post(this.url.correctionUserList, obj);
}

  getUserDetailsEntityMaster(entityId: any) {
    const entityIdEncr = encodeURIComponent(this.ced.encryptAesToString(entityId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getUserDetailsEntityMaster + '?entityMasterIdEncr=' + entityIdEncr);
  }

  getUserDetailsBySection(sectionId: any) {
    const sectionIdEncr = encodeURIComponent(this.ced.encryptAesToString(sectionId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getUserDetailsBySection + '?sectionIdEncr=' + sectionIdEncr);
  }
getUniversityTypeById(universityId: any) {
  return this.http.get(this.url.getUniversityTypeById + '?universityId=' + universityId);
}
  // getAllDCISections
  getAllDCISections() {
    return this.http.get(this.url.getAllDCISections);
  }

  collegeByState() {
    return this.http.get(this.url.collegeByState);
  }

  findAllConstitution() {
    return this.http.get(this.url.findAllConstitution);
  }

  findAllUniversityType() {
    return this.http.get(this.url.findAllUniversityType);
  }

  getListOfCourse() {
    return this.http.get(this.url.getListOfCourse);
  }

  getListOfSpecialization() {
    return this.http.get(this.url.getListOfSpecialization);
  }

  getListOfSpecializationByCourse(courseId: any) {
    var encryptedId = encodeURIComponent(this.ced.encryptAesToString(courseId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getListOfSpecializationByCourse + "?courseIdEncr=" + encryptedId);
  }

  //getCollegeDetails
  getCollegeMasterDetails(id: any) {
    var collegeIdEncr = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString())
    return this.http.get(this.url.getCollegeMasterDetails + "?collegeIdEncr=" + collegeIdEncr);
  }

  getMDSUnitsBySpec(obj: any) {
    return this.http.post(this.url.getMDSUnitsBySpec, obj);
  }

  getCurrentAcademicYear() {
    return this.http.get(this.url.getCurrentAcademicYear);
  }

  getPreviousAcademicYear() {
    return this.http.get(this.url.getPreviousAcademicYear);
  }

  getDairyDakAcademicYear() {
    return this.http.get(this.url.getDairyDakAcademicYear);
  }

  getCurrentDateAcademicYear() {
    return this.http.get(this.url.getCurrentDateAcademicYear);
  }
  
  getCurrentDate() {
    return this.http.get(this.url.getCurrentDate);
  }

  getStudentNationalityList() {
    return this.http.get(this.url.getStudentNationalityList);
  }

  getStudentCategoryList() {
    return this.http.get(this.url.getStudentCategoryList);
  }

  forgotUser(studentDetailsobj: any) {
    return this.http.post(this.url.forgotUser, studentDetailsobj);
  }

  getAllStaffMasterList(staffSearchCriteria: any) {
    return this.http.post(this.url.getAllCollegeStaffList, staffSearchCriteria);
  }

}